"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "PlaidError", {
    enumerable: !0,
    get: function() {
        return PlaidError;
    }
});
class PlaidError extends Error {
    constructor(error){
        var key, value;
        super(toErrorMessage(error)), value = void 0, (key = "error") in this ? Object.defineProperty(this, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : this[key] = value, this.error = error;
    }
}
const toErrorMessage = (error)=>`${error.id} ${error.reason} ${error.message}`;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy90ZXN0L3BsYWlkL21vZGVscy9QbGFpZEVycm9yLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBpbnRlcmZhY2UgUGxhaWRFcnJvck1lc3NhZ2Uge1xuICAgIGlkOiBzdHJpbmdcbiAgICBtZXNzYWdlOiBzdHJpbmdcbiAgICByZWFzb246IHN0cmluZ1xufVxuXG5leHBvcnQgY2xhc3MgUGxhaWRFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgICBjb25zdHJ1Y3RvcihwdWJsaWMgZXJyb3I6IFBsYWlkRXJyb3JNZXNzYWdlKSB7XG4gICAgICAgIHN1cGVyKHRvRXJyb3JNZXNzYWdlKGVycm9yKSlcbiAgICB9XG59XG5cbmNvbnN0IHRvRXJyb3JNZXNzYWdlID0gKGVycm9yOiBQbGFpZEVycm9yTWVzc2FnZSkgPT4ge1xuICAgIHJldHVybiBgJHtlcnJvci5pZH0gJHtlcnJvci5yZWFzb259ICR7ZXJyb3IubWVzc2FnZX1gXG59XG4iXSwibmFtZXMiOlsiUGxhaWRFcnJvciIsIkVycm9yIiwiY29uc3RydWN0b3IiLCJlcnJvciIsInRvRXJyb3JNZXNzYWdlIiwiaWQiLCJyZWFzb24iLCJtZXNzYWdlIl0sIm1hcHBpbmdzIjoiOzs7bUNBTWFBOzs7ZUFBQUE7OztBQUFOLE1BQU1BLG1CQUFtQkM7SUFDNUJDLFlBQVksQUFBT0MsS0FBd0IsQ0FBRTs7UUFDekMsS0FBSyxDQUFDQyxlQUFlRDs7Ozs7cUNBRE5BLFFBQUFBO0lBRW5CO0FBQ0o7QUFFQSxNQUFNQyxpQkFBaUIsQ0FBQ0QsUUFDYixDQUFDLEVBQUVBLE1BQU1FLEVBQUUsQ0FBQyxDQUFDLEVBQUVGLE1BQU1HLE1BQU0sQ0FBQyxDQUFDLEVBQUVILE1BQU1JLE9BQU8sQ0FBQyxDQUFDIn0=